const getExperiments = state => state.experiments;

export const isExperimentEnabled = (state, name) => getExperiments(state)[name] === 'true';



// WEBPACK FOOTER //
// ./app/selectors/experiments-selectors.js